<script>
    let resources_items = [
        {
            name: "Pricing",
            page: "pricing",
        },
        {
            name: "FAQs",
            page: "Faqs",
        },
    ];
</script>

<div class="desktop">
    <div class="footer-section">
        <div class="left-section">
            <div class="left-section-content">
                <div class="img-wrapper">
                    <img src="/images/footer_logo.svg" alt="" width="100%" />
                </div>
                <h5 style="color: white; font-size: 1vw;">
                    When you need results !
                </h5>
                <div class="social-logos">
                    <img src="/images/twitter.svg" alt="" width="100%"  on:click={() => (location.href = "https://twitter.com/automasonai")}/>
                    <img src="/images/linkedIn.svg" alt="" width="100%"  on:click={() => (location.href = "https://www.linkedin.com/company/automason")}/>
                    <!-- <img src="/images/insta.svg" alt="" width="100%" /> -->
                </div>
            </div>
        </div>
        <div class="right-section">
            <div class="right-section-list">
                <ul class="list-class">
                    <li style="font-size: 1.563vw;font-weight: 600;  cursor:  default;">
                        Resources
                    </li>
                    {#each resources_items as navitem}
                        <li
                            class="list-item"
                            on:click={() => (location.href = navitem.page)}
                        >
                            <div>
                                <h5 style="font-size: 1.042vw;">
                                    {navitem.name}
                                </h5>
                            </div>
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="mobile">
    <div class="footer-section">
        <div class="left-section">
            <div class="left-section-content">
                <div class="img-wrapper">
                    <img src="/images/footer_logo.svg" alt="" width="100%" />
                </div>
                <div class="text-wrraper">
                    <h5 style="color: white; font-size: 4.673vw;">
                        When you need results !
                    </h5>
                </div>
                <div class="social-logos">
                    <img src="/images/twitter.svg" alt="" width="100%"  on:click={() => (location.href = "https://twitter.com/automasonai")}/>
                    <img src="/images/linkedIn.svg" alt="" width="100%"  on:click={() => (location.href = "https://www.linkedin.com/company/automason")}/>
                    <!-- <img src="/images/insta.svg" alt="" width="100%" /> -->
                </div>
            </div>
        </div>
        <div class="right-section">
            <div class="right-section-list">
                <ul class="list-class">
                    <li style="font-size: 4.673vw;font-weight: 600;  cursor: default;">
                        Contact
                    </li>
                </ul>
                <ul class="list-class">
                    <li
                        style="font-size: 4.673vw;font-weight: 600; padding-bottom: 2vw; cursor:  default;"
                    >
                        Resources
                    </li>
                    {#each resources_items as navitem}
                        <li
                            class="list-item"
                            on:click={() => (location.href = navitem.page)}
                        >
                            <div>
                                <h5
                                    style="font-size: 4.206vw; font-weight:300;"
                                >
                                    {navitem.name}
                                </h5>
                            </div>
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    </div>
</div>

<style>
    li{
        cursor: pointer;
    }
    .footer-section {
        background-color: #191919;
        width: 100%;
        height: 28.854vw;
        display: flex;
        gap: 43.4vw;
    }
    .left-section-content {
        margin-left: 7.292vw;
        margin-top: 7.865vw;
    }
    .left-section-content .img-wrapper {
        width: 17.708vw;
        height: 2.292vw;
        margin-bottom: 1.5vw;
    }
    .social-logos {
        display: flex;
        width: 2.083vw;
        height: 2.083vw;
        gap: 1.2vw;
        margin-top: 6vw;
        cursor: pointer;
    }
    .right-section {
        margin-top: 7.5vw;
    }
    .list-class {
        list-style: none;
        color: #ffffff;
    }
    .right-section-list {
        display: flex;
        gap: 5.458vw;
    }
    .list-item {
        margin-top: -0.2vw;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
        .footer-section {
            height: 128.720vw;
            display: flex;
            gap: 14.486vw;
            flex-direction: column;
            overflow-y: hidden;
        }
        .left-section {
            margin-left: auto;
            margin-right: auto;
            justify-content: center;
            margin-top: 10.047vw;
        }
        .left-section-content {
            margin-left: 0;
            margin-top: 0;
            text-align: -webkit-center;
        }
        .left-section-content .img-wrapper {
            width: 39.72vw;
            height: 5.14vw;
            margin-bottom: 5.841vw;
        }
        .text-wrraper {
            width: 55.8vw;
            height: 6.542vw;
        }
        .social-logos {
            width: 9.346vw;
            height: 9.346vw;
            gap: 4.673vw;
            margin-top: 17.991vw;
            margin-left: auto;
            margin-right: auto;
            justify-content: center;
        }
        .right-section {
            margin-top: 0;
            margin-left: auto;
            margin-right: auto;
            justify-content: center;
            margin-bottom: 14.486vw;
        }
        .right-section-list {
            gap: 16.822vw;
        }
        .list-item {
            margin-top: 8.8vw;
        }
    }
</style>
